import { useSearchParams } from 'react-router-dom';

import { useFeatureFlags } from 'ha/modules/FeatureFlags';

import { MUL_QUERY_KEY } from '../constants';

const useMulFeatureFlags = (country?: string) => {
  const [searchParams] = useSearchParams();
  const hasMulQuery = searchParams.get(MUL_QUERY_KEY) || undefined;

  const { tenantMULFlow, advertiserMulCRUD, advertiserAllowMulCreation } =
    useFeatureFlags();

  const isTenantMULFlowEnabled = tenantMULFlow === 'on';

  const isAdvertiserMulCRUDEnabled =
    advertiserMulCRUD === 'on' && (!!country || !!hasMulQuery);

  const isAdvertiserAllowMulCreationEnabled =
    advertiserAllowMulCreation === 'on';

  return {
    isTenantMULFlowEnabled,
    isAdvertiserMulCRUDEnabled,
    isAdvertiserAllowMulCreationEnabled,
  };
};

export { useMulFeatureFlags };
